import { Link, Navigate } from "react-router-dom";
import { X } from "lucide-react";
import { useWishlist } from "../context/WishlistContext";
import { useAuth } from "../context/AuthContext";
import { FILE_URL, formatBRL, displayBrand } from "../lib/api";

export default function WishlistPage() {
  const { items, remove } = useWishlist();
  const { user, loading } = useAuth();

  if (loading) return <div className="p-20 text-center text-[#A8A8A8]">Carregando...</div>;

  // Not logged in → redirect to /login with a return path so we come back here.
  if (!user) {
    return <Navigate to="/login?redirect=/wishlist" replace />;
  }

  return (
    <div className="max-w-7xl mx-auto px-6 py-16" data-testid="wishlist-page">
      <div className="text-center mb-12">
        <p className="overline text-[#A8A8A8] mb-3">Olá, {user.name?.split(" ")[0] || "amor"}</p>
        <h1 className="font-display text-4xl md:text-5xl">Peças que te encantaram</h1>
      </div>

      {items.length === 0 ? (
        <div className="text-center py-20">
          <p className="font-italic-display text-2xl text-[#6B6B6B] mb-6">Sua wishlist ainda está vazia.</p>
          <Link to="/joias/todos" className="btn-primary">Explorar peças</Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {items.map((p) => {
            const img = p.images?.[0] ? FILE_URL(p.images[0]) : "https://images.unsplash.com/photo-1611652022419-a9419f74343d?w=600&q=80";
            return (
              <div key={p.id} className="relative" data-testid={`wishlist-item-${p.id}`}>
                <button
                  onClick={() => remove(p.id)}
                  data-testid={`remove-${p.id}`}
                  className="absolute top-2 right-2 z-10 w-8 h-8 bg-white border border-[#E8E4DF] flex items-center justify-center hover:border-[#B8A88A]"
                >
                  <X size={14} />
                </button>
                <Link to={`/produto/${p.id}`} className="block">
                  <div className="aspect-[3/4] bg-[#FAF9F7] overflow-hidden">
                    <img src={img} alt={p.name} className="w-full h-full object-cover img-hover" />
                  </div>
                  {(() => { const b = displayBrand(p); return b ? <p className="text-[10px] uppercase tracking-wider text-[#A8A8A8] mt-3">{b}</p> : null; })()}
                  <p className="font-display text-lg mt-1">{p.name}</p>
                  <p className="text-sm">{formatBRL(p.price)}</p>
                </Link>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
